/* eslint no-param-reassign: "error" */

export default {
  SET_ALL_FREQUENCIES(state, data) {
    state.frequencies = data;
  },
  SET_LEASE_FREQUENCIES(state, data) {
    state.leaseFrequencies = data;
  },
};
